import { useState } from "react";
import Calendar from "react-calendar";
import cn from "classnames";
import {
    useLocale,
    useTranslations
} from "next-intl";
import dayjs from "dayjs";
import {
    Button,
    Popover
} from "antd";
import style from './datePreset.module.scss';
import 'dayjs/locale/uk'
import { DateIcon } from "@/theme/assets/icons";

export const PopoverDatePreset = (
    {
        onChange,
        initData,
        date
    }
) =>{
    const locale = useLocale();
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState(getPresetActiveTitle(initData));

    const toggle = (nextOpen) =>{
        setOpen(nextOpen);
    }
    const formatDateRange = (start, end) => {
        const options = { day: 'numeric', month: 'short', year: '2-digit' };

        const format = (dateStr) => {
            const date = new Date(dateStr);

            if (String(dateStr).includes('T')) {
                date.setUTCHours(0, 0, 0, 0);
            }
            return date.toLocaleDateString(locale === 'en' ? 'en-GB' : locale, options).replace(',', '');
        };

        return `${format(start)} - ${format(end)}`;
    }

    return(
        <Popover
            overlayClassName={style.popover_date_preset}
            content={(
                <DatePreset
                    finish={(value)=>{
                        if (onChange){
                            onChange(value?.date ? value.date : null, value.key)
                        }
                        setTitle(getPresetActiveTitle(value.key))
                        setOpen(false)
                    }}
                    initData={initData}
                    setOpen={setOpen}
                />
            )}
            trigger="click"
            placement={'bottomRight'}
            arrow={false}
            open={open}
            onOpenChange={toggle}
        >
            <Button
                className={cn(style.popover_button_preset, {
                    [style.active]: open
                })}
                icon={(
                    <DateIcon />
                )}
            >
                {formatDateRange(date.start, date.end)}
            </Button>
        </Popover>
    )
}

export const DatePreset = ({finish, initData, setOpen}) => {
    const locale = useLocale();
    const t = useTranslations('date_preset');
    const [value, setValue] = useState(()=>{
        if (initData){
            const find = presetsDate.find((preset)=>preset.key === initData)

            if (find){
                return find
            }
        }
        return {}
    });

    const onCancel = () =>{
        setOpen(false)
    }

    const onFinish = () =>{
        if (finish){
            const format = 'YYYY-MM-DD HH:mm:ss'
            finish({
                date: {
                    start: dayjs(value.date[0]).format(format),
                    end: dayjs(value.date[1]).format(format),
                },
                key: value.key,
            })
        }
    }

    return (
        <div className={style.date_preset}>
            <div className={style.date_preset_wrapper}>
                <div className={style.date_preset_content}>
                    <Calendar
                        formatShortWeekday={(locale, date) => {
                            return new Intl.DateTimeFormat(locale, {weekday: "long"})
                                .format(date)
                                .substring(0, 2)
                        }}
                        locale={locale}
                        selectRange={true}
                        onChange={(value) => {
                            setValue({
                                key: 'different',
                                date: value
                            })
                        }}
                        value={value.date}
                    />

                    <Presets
                        active={value.key}
                        onClick={(value) => {
                            setValue(value)
                        }}
                    />
                </div>
                <div className={style.footer_buttons}>
                    <Button
                        onClick={onCancel}
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={onFinish}
                    >
                        {t('apply')}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export const presetsDate = [
    {
        title: 'Last day',
        date: [
            dayjs().locale('uk').startOf('day').toDate(),
            dayjs().locale('uk').endOf('day').toDate(),
        ],
        key: 'day',
    },
    {
        title: 'Last week',
        date: [
            dayjs().locale('uk').startOf('week').toDate(),
            dayjs().locale('uk').endOf('week').toDate(),
        ],
        key: 'week',
    },
    {
        title: 'Last 2 week',
        date: [
            dayjs().locale('uk').startOf('week').subtract(1, 'week').toDate(),
            dayjs().locale('uk').endOf('week').toDate(),
        ],
        key: 'two_week',
    },
    {
        title: 'Last month',
        date: [
            dayjs().locale('uk').subtract(1, 'month').startOf('month').toDate(),
            dayjs().locale('uk').subtract(1, 'month').endOf('month').toDate(),
        ],
        key: 'month',
    },
    {
        title: 'Last 6 month',
        date: [
            dayjs().locale('uk').subtract(6, 'month').startOf('month').toDate(),
            dayjs().locale('uk').subtract(1, 'month').endOf('month').toDate(),
        ],
        key: 'six_month',
    },
    {
        title: 'Last year',
        date: [
            dayjs().locale('uk').subtract(1, 'year').startOf('year').toDate(),
            dayjs().locale('uk').subtract(1, 'year').endOf('year').toDate(),
        ],
        key: 'year',
    },
    {
        title: 'Different',
        key: 'different',
        value: [
            null,
            null,
        ]
    }
]

const getPresetActiveTitle = (key) =>{
    const find = presetsDate.find((preset)=>preset.key === key)

    if (find){
        return find.title
    }

    return 'Date preset'
}

const Presets = ({onClick, active}) =>{
    const t = useTranslations('date_preset');
    return (
        <div className={style.buttons_preset}>
            {presetsDate.map((button) => (
                <Button
                    key={button.title}
                    className={cn(style.button_preset, {[style.active]: active === button.key})}
                    type="text"
                    onClick={() => {
                        if (onClick && button.key !== 'different') {
                            onClick({
                                date: button.date,
                                key: button.key,
                            })
                        }
                    }}
                >
                    {t(`${button.key}`)}
                </Button>
            ))}
        </div>
    )
}